/** This controller is used by favorite contact portlet and favorite view modals in other portlets */
define(function (require) {
	return function (config) {
		const FavoritesCollection = require('civicsCollections/portal/favorite_contact_collection');
		const FavoriteModel = require('civicsModels/portal/favorite_contact_model');
		const ApplicantModel = require('civicsModels/applicant_model');
		const InviteModel = require('civicsModels/portal/invitation_model');

		const ViewManager = require('civicsUtils/view_manager');

		//sortByPriority -> used in add applicant/invite applicant modals to sort contact list by priority
		//sortByPriority is based on if contact is expired or has no email address
		let _loadFavorites = (sortByPriority=false, fromInvite = false) => {
			let favorites = new FavoritesCollection();
			let favoritesPromise = $.Deferred();
			
			favorites.fetch({
				success: (collection, response, options) => {
					let result;

					//Sort alphabetically
					let sortedList = _.sortBy(response.data, function (model) {
						const name = model.firstName?.trim().toLowerCase() || model.lastName?.trim().toLowerCase() || '';
						//re-sort to push unavailable ones down
						if (sortByPriority) {
							const isAvailable = fromInvite
								? model.hasEmail && !model.isExpired
								: !model.isExpired;
							return [!isAvailable, name]; 
						} else{
							return name;
						}	
					});

					result = sortedList;

					favoritesPromise.resolve({
						favorites: result
					});
				},
				error: (collection, response, options) => {
					ViewManager.errorToWindow(response);
					favoritesPromise.reject(response);
				}
			});
			
			return favoritesPromise;
		};

		//note column is the only column we can update now
		let _editFavorites = (favoriteId, newNote) => {
			let favoritesPromise = $.Deferred();
			const favorite = new FavoriteModel({id: favoriteId});
				favorite.set({
					"notes": newNote			
				});	
				favorite.save().done((response)=>{
					favoritesPromise.resolve(response.data);
				}).fail((response)=>{
					favoritesPromise.reject(response);	
				});	
				return favoritesPromise;

		};

		let _deleteFavorite = (favoriteId) => {
			let favoritesPromise = $.Deferred();
			const favorite = new FavoriteModel();
			favorite.set({ id: favoriteId});

			favorite.destroy().done((response)=>{
				favoritesPromise.resolve();
			}).fail((response)=>{
				favoritesPromise.reject(response);	
			});	
			return favoritesPromise;;
		}
		/** Functions used in adding applicants or invites via select from favorites */
				//builds the applicant model
		let _buildApplicantData = (input, instrumentType = null, instrumentID = null, mergeExtra = {}) => {
			const dataArray = Array.isArray(input) ? input : [input];

			return dataArray.map((data) => {
				if (typeof data.toJSON === 'function') { //check if we need to convert
					data = data.toJSON();
				}
				const mergedData = {
				isPrimary: false,
				isRespAccountHolder: false,
				findOrCreateContact: "false",
				applicationId: instrumentID,
				capacity: data.capacity,
				contact: {
					id: data.contactId,
					identity: {
						firstName: data.firstName,
						lastName: data.lastName
					}
				},
				contactType: data.contactType,
				contactTypeDescription: data.contactTypeDescription,
				...mergeExtra 
				};

				const applicantModel = new ApplicantModel();
				applicantModel.instrumentType = instrumentType;
				applicantModel.set(mergedData);

				return applicantModel;
			});
			};		
		let _buildInviteData = (input, instrumentType = null, instrumentID = null, productFamily = null, mergeData = {}) => {
			const dataArray = Array.isArray(input) ? input : [input];
			let hasInstrument = instrumentID != null && instrumentType != null;
			return dataArray.map((data) => {
				if (typeof data.toJSON === 'function') { //check if we need to convert
					data = data.toJSON();
				}
				let inviteModel = new InviteModel();
				if(hasInstrument){
					inviteModel.set({
						applicantType: data.contactType,
						capacity: data.capacity.code,
						instrumentNumber: instrumentID,
						productFamily: instrumentType,
						contactId: data.contactId
					});
				} else{
					
					inviteModel.set({
						applicantType:{
							code:mergeData.contactType,
							description: mergeData.contactTypeDescription
						},
						capacity: mergeData.capacity,
						contactId: data.contactId,
						contact:{
							identity: {
								firstName: data.firstName,
								lastName: data.lastName
							}
						}
					})				

				}
				return inviteModel;
			});
		}

		let _addApplicants = (applicants) =>{
			let applicantsPromise = $.Deferred();

			applicants.save().done((response)=>{
				applicantsPromise.resolve(response.data);
			}).fail((response)=>{
				applicantsPromise.reject(response);	
			});	
			return applicantsPromise;;

		}
		let _inviteContacts = (contacts) =>{
			let contactsPromise = $.Deferred();

			contacts.save().done((response)=>{
				contactsPromise.resolve(response.data);
			}).fail((response)=>{
				contactsPromise.reject(response);	
			});	
			return contactsPromise;;

		}
		//setting contactType/capacityCode to empty string if they are undefined/null for the combination list
		//possible combinations: 1147_1_2, 1147__2, 1147__, 1147_1_ depending on the config**/
		let _generateApplicantKey = function({ contactId, contactType, capacityCode }) {
			return `${contactId}_${contactType ?? ''}_${capacityCode ?? ''}`;
		};

		//gets and extracts data -> this is a long code since we are checking for model formattings as the models have different attribute names and object
		/**isSubmit -> used in submit-record
		 * isInvite -> is data from invite or applicant
		setting contactType/capacityCode to empty string if they are undefined/null for the combination list
		possible combinations: 1147_1_2, 1147__2, 1147__, 1147_1_ depending on the config**/
		let _getContactData = function(model, config, isSubmit, isInvite = false) {
			let showApplicantType = config.showApplicantType;
			let showCapacity = config.showCapacity;
			let contactId = '';
			let contactType = '';
			let capacityCode = '';
			
			if (!isInvite) {
				if (typeof model?.toJSON === 'function') {
					model = model.toJSON();
				}
				contactId = isSubmit ? model.contact?.id : model.contactId;
				contactType = showApplicantType ? (model.contactType ?? '') : '';

				if (showCapacity) {
					if (isSubmit) {
						capacityCode = typeof model.get === 'function'
							? model.get('capacity.code') ?? ''
							: model.capacity?.code ?? '';
					} else {
						capacityCode = typeof model.capacity === 'object' && model.capacity !== null
							? model.capacity.code ?? ''
							: model.capacity ?? '';
					}
				}
			} else {
				if (typeof model?.toJSON === 'function') {
					model = model.toJSON();
				}
				contactId = model.contactId;
				contactType = showApplicantType ? (isSubmit ? model.applicantType?.code : model.contactType) : '';
				capacityCode = showCapacity ? (isSubmit ? model.capacity?.code ?? '' : model.capacity?.code ?? '') : '';
			}
			return { contactId, contactType, capacityCode };
		};

		let _getValidApplicants = function(applicantData, applicantCollection, config, childViews, isSubmit = false) {
			const existingKeys = [];

			applicantCollection.forEach(model => {
				let { contactId, contactType, capacityCode } = _getContactData(model, config, isSubmit);
				const key = _generateApplicantKey({ contactId, contactType, capacityCode });

				if (!existingKeys.includes(key)) {
					existingKeys.push(key);
				}
			});

			if (config.submitInvitationsList) {
				const rawInvites = config.submitInvitationsList.toJSON();
				rawInvites.forEach(model => {
					let { contactId, contactType, capacityCode } = _getContactData(model, config, isSubmit, true);
					const key = _generateApplicantKey({ contactId, contactType, capacityCode });
					if (!existingKeys.includes(key)) {
						existingKeys.push(key);
					}
				});
			}

			const uniqueApplicants = [];
			applicantData.forEach(contact => {
				let { contactId, contactType, capacityCode } = _getContactData(contact, config, isSubmit);
				const key = _generateApplicantKey({ contactId, contactType, capacityCode });

				const matchingView = childViews?.find((childView) => {
					const modelContactId = childView.model.get('contactId');
					return modelContactId === contactId;
				});

				if (existingKeys.includes(key)) {
					if (matchingView) {
						const error = {
							validationError: {
								nameColumn: i18n.t('CIVICS.ADD_INSTRUMENT.COMMON_ADD_APPLICANT.DUPLICATE_CONTACT'),
							}
						};
						ViewManager.errorToWindow(error, matchingView);
						return;
					}
				} else {
					uniqueApplicants.push(contact);
					if (matchingView) {
						ViewManager.resetErrorMessages(matchingView);
					}
				}
			});

			return uniqueApplicants;
		};

		let _getValidInvites = function(inviteData, invitationCollection, config, childViews, isSubmit = false) {
			let showApplicantType = config.showApplicantType;
			let showCapacity = config.showCapacity;
			invitationCollection = invitationCollection.toJSON();
			const existingKeys = [];

			invitationCollection.forEach(model => {
				let { contactId, contactType, capacityCode } = _getContactData(model, config, isSubmit, true);
				const key = _generateApplicantKey({ contactId, contactType, capacityCode });

				if (!existingKeys.includes(key)) {
					existingKeys.push(key);
				}
			});

			if (config.submitApplicantsList) {
				const rawInvites = config.submitApplicantsList.toJSON();
				rawInvites.forEach(model => {
					const contactId = model.contact.id;
					const contactType = showApplicantType ? (model.contactType ?? '') : '';
					const capacityCode = showCapacity ? (isSubmit ? model.capacity?.code ?? '' : model.capacity?.code ?? '') : '';

					const key = _generateApplicantKey({ contactId, contactType, capacityCode });
					if (!existingKeys.includes(key)) {
						existingKeys.push(key);
					}
				});
			}

			const uniqueApplicants = [];
			inviteData.forEach(contact => {
				let { contactId, contactType, capacityCode } = _getContactData(contact, config, isSubmit, true);
				const key = _generateApplicantKey({ contactId, contactType, capacityCode });

				const matchingView = childViews?.find((childView) => {
					const modelContactId = childView.model.get('contactId');
					return modelContactId === contactId;
				});

				if (existingKeys.includes(key)) {
					if (matchingView) {
						const error = {
							validationError: {
								nameColumn: i18n.t('CIVICS.ADD_INSTRUMENT.COMMON_ADD_APPLICANT.DUPLICATE_CONTACT'),
							}
						};
						ViewManager.errorToWindow(error, matchingView);
					}
				} else {
					uniqueApplicants.push(contact);
					if (matchingView) {
						ViewManager.resetErrorMessages(matchingView);
					}
				}
			});
			return uniqueApplicants;
		};

		let _processContactsForSubmission = function(childViews, isPortalInstrument, isInviteProcess, config, additionalCapacityTypes) {
			let tempApplicantData = [];
			let allValid = true;
			//const isChildViewCollection = childViews && childViews instanceof Backbone.Collection;

			const processItem = function(item, data) {
				if (isPortalInstrument) {
					if (isInviteProcess) {
						const inviteModel = _buildInviteData(item, null, null, null, data);
						const finalModel = inviteModel[0];
						finalModel.set('isFavorite', true, { silent: true });
						tempApplicantData.push(finalModel);
					} else {
						const applicantModel = _buildApplicantData(item, null, null, data);
						const finalModel = applicantModel[0];
						finalModel.set('isFavorite', true, { silent: true });
						tempApplicantData.push(finalModel);
					}
				} else {
					data.contactId = item.get('contactId');
					tempApplicantData.push(data);
				}
			};

			childViews.each(function (childViewOrModel) {
				let data, model;

				if (typeof childViewOrModel.getData === 'function') {
					data = childViewOrModel.getData();
					if (!data || !data.isValid) {
						allValid = false;
						return;
					}
					model = childViewOrModel.model;
				}
				else {
					// Handle model directly. If no getData, we set defaultdata for contactType and capacity types
					data = _buildDefaultData(config, additionalCapacityTypes);
					model = childViewOrModel;
				}

				if (data && model) {
					processItem(model, data);
				}
			});

			if (!allValid) {
				return;
			}

			return tempApplicantData;
		};
		let _buildDefaultData = function(config, additionalCapacityTypes) {
			let data = {};

			let capacityCode = "";
			let capacityDesc = "";

			if (additionalCapacityTypes && additionalCapacityTypes.length === 1) {
				capacityCode = additionalCapacityTypes[0].code;
				capacityDesc = additionalCapacityTypes[0].description;
			}

			data.capacity = { code: capacityCode, description: capacityDesc };

			//TradeLicense must have ApplicantType set to 1
			if (config.instrumentType?.toLowerCase() === 'tradelicense') {
				data.contactType = "1";
			}

			data.contactTypeDescription = { code: "" };

			// Default the applicant type if not shown
			if (!config.showApplicantType) {
				const type = config.instrumentType?.toLowerCase();
				if (type === "tradelicense") {
					data.contactType = 2;
				} else if (type === "businesslicense") {
					data.contactType = 1;
				} else {
					data.contactType = 4;
				}
			}

			data.isValid = true;

			return data;
		};

		let _getComparator = function(sortType, reverseSort) {
			return function(a, b) {
				let aVal, bVal;

				if (sortType === 'firstName') {
					aVal = a.get('firstName') || a.get('lastName') || '';
					bVal = b.get('firstName') || b.get('lastName') || '';
				} else {
					aVal = a.get(sortType) == null ? '' : a.get(sortType);
					bVal = b.get(sortType) == null ? '' : b.get(sortType);
				}

				if (typeof aVal === 'string' && typeof bVal === 'string') {
					return reverseSort
						? bVal.localeCompare(aVal)
						: aVal.localeCompare(bVal);
				} else {
					return reverseSort ? (bVal - aVal) : (aVal - bVal);
				}
			};
		}		
		return {
			loadFavorites: _loadFavorites,
			editFavorites: _editFavorites,
			deleteFavorite: _deleteFavorite,
			addApplicants: _addApplicants,
			inviteContacts: _inviteContacts,
			buildApplicantData: _buildApplicantData,
			buildInviteData: _buildInviteData,
			getComparator: _getComparator,
			processContactsForSubmission: _processContactsForSubmission,
			getValidApplicants: _getValidApplicants,
			getValidInvites: _getValidInvites,
        }
	}
});